<div class="organizer d-flex flex-grow-1 w-100">
    <div class="document-list d-flex flex-column flex-grow-1">
        <h4>
            Attachments
            <ag-grid-row-count [gridApi]="documentGridApi"
                               [gridOptions]="documentGridOptions"
                               [gridTracker]="documentGridTracker">
            </ag-grid-row-count>
        </h4>
        <div class="d-flex flex-grow-1 w-100">
            <ws-ag-grid-angular [gridOptions]="documentGridOptions"
                                [defaultSizeToContent]="true"
                                (gridReady)="onDocumentAgGridReady($event)"
                                [additionalButtons]="additionalButtons"
                                [gridId]="documentGridId">
            </ws-ag-grid-angular>
        </div>
    </div>
    <div class="selection-list d-flex flex-column ms-3"
         ws-resizable
         [rFlex]="true"
         [rMinWidth]="400"
         rDragAxis="x"
         rDragPosition="left">
        <h4>
            Selected Attachments
            <ag-grid-row-count [gridApi]="selectionGridApi"
                               [gridOptions]="selectionGridOptions"
                               [gridTracker]="selectionGridTracker"></ag-grid-row-count>
        </h4>
        <div class="d-flex flex-grow-1 ps-1 w-100">
            <ws-ag-grid-angular [gridId]="selectionGridId"
                                [gridOptions]="selectionGridOptions"
                                [defaultSizeToContent]="true"
                                [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                                (gridReady)="onSelectionAgGridReady($event)"
                                (bulkDelete)="bulkDelete()">
            </ws-ag-grid-angular>
        </div>
    </div>
</div>
